<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>

      <header class="head">
        <img class="classify" @click="table=!table" src="../../static/images/Normal08/more.png">
      </header>
      <section class="main-body">
        <div class="default_box">
          <viewer @inited="inited" ref="viewer">
            <div class="swiper-container banner">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-if="datas.focus && datas.focus_pics_is_show == 1"
                  v-for="(item, index) in datas.focus" v-bind:key="index"><img :src="item.img"></div>
                  <div class="swiper-slide" v-if="!datas.focus || datas.focus.length <= 0">
                    <img src="../../static/images/AntiFake03/banner.png">
                  </div>
              </div>
            </div>
          </viewer>
        </div>
        <div class="maib-box">
          <ul>
            <li>品牌：{{ datas.product.name }}</li>
            <li v-if="licensor">总授权商：{{ licensor.name }}</li>
            <li v-if="dealer">被授权商：{{ dealer.name }}</li>
            <li v-if="brand">品类：{{ brand.name }}</li>
            <li v-if="datas.product.attribute" v-for="val in datas.product.attribute">
              <template v-if="val.key || val.value">
                {{val.key}}：{{ val.value }}
              </template>
            </li>
            <li v-if="datas.product.period">保质期：{{ datas.product.period }}</li>
            <li v-if="datas.product.unit">商品规格：{{ datas.product.unit }}</li>
            <li v-if="datas.product.introduce">商品描述：{{ datas.product.introduce }}</li>
            <li>查询次数：{{datas.scan_count}}</li>
						<li>首次查询时间：{{datas.scan_first_time}}</li>
            <li v-if="datas.scan_count > 1">你所查询的条码已被多次扫描，谨防假冒！</li>
          </ul>
        </div>
      </section>

      <footer class="fooder">zcyj Inc. © 2016-2030</footer>

      <div class="mask-box" v-if="table">
        <img class="close" @click="table=!table" src="../../static/images/Normal08/close_01.png">
        <ul class="nav_list nav_list_white">
          <li class="query-tsecure" @click="pageJump('/Secure')">
            <img src="../../static/images/Normal08/icon_17.png">
            真伪查询
          </li>
          <li class="query-result" @click="table=!table">
            <img src="../../static/images/Normal08/icon_18.png">
            查询结果
          </li>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
let self;
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
export default {
  name: 'Normal08',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data() {
    return {
      code: null,
      vcode: null,
      count: 2,
      datas: null,
      hintTxt: null,
      Loading: {
        type: 1,
        txt: "数据请求中..."
      },
      table:false,
      brand:{name:null},
      licensor:{name:null},
      dealer:{name:null}
    }
  },
  created() {
    self = this;

    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      self.GetDemoDatas(this.$route.query.pid, this.$route.query.rid);  //获取演示模板信息
    } else {
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }

  },
  updated() {
    new Swiper('.banner')
  },
  methods: {
    GetDemoDatas(pid, rid) {
      axios.get(self.GetServerUrl(1) + "template_product/" + pid + "/" + rid)
        .then(function (response) {
          let datas = response.data.meta;
          let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息

          if (datas.scan_count) {
            datas.scan_count = datas.scan_count;
          } else {
            datas.scan_count = 1;
          }
          datas.scan_first_time = "2017-10-31 12:12";
          datas.scan_first_address = "广东省深圳市";
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          } else {
            if (defaultDatas.ref) {
              datas.ref = JSON.parse(defaultDatas.ref);
            }
          }
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          if (datas.batch) {
            datas.batch = JSON.parse(datas.batch);
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }

          //默认信息
          if (!datas.process) {
            datas.process = defaultDatas.process;
          }
          if (!datas.process_demo) {
            datas.process_demo = defaultDatas.process_demo;
          }
          if (!datas.dealer) {
            datas.dealer = defaultDatas.dealer;
          }

          self.datas = datas;
          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    GetDatas() {
      axios.get(self.GetServerUrl(1) + "query/" + self.code)
        .then(function (response) {
          let datas = response.data.meta.product_template;
          datas.scan_count = response.data.meta.scan_count;  //扫码次数
          datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
          datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
          datas.verify = response.data.meta.verify; //防伪码

          //自定义属性
          if (response.data.meta.activation_a) {
            datas.attribute = JSON.parse(response.data.meta.activation_a);
          }

          //上海红坊定制内容
          if(datas.dealer){
            let dealerAttribute = JSON.parse(datas.dealer[0].attribute);
            self.dealer = datas.dealer[0]; //经销商内容
            self.brand = dealerAttribute.brand; //品牌内容
            self.licensor = dealerAttribute.licensor; //授权商
          }

          //焦点图
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          //自定义栏目
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          }
          //自定义菜单
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }
          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }
          //批次信息
          if (datas.batch) {
            if (datas.batch.qc) {
              datas.batch.qc = JSON.parse(datas.batch.qc);
            }
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;
          self.datas = datas;

          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    CodeVerify() {
      axios.get(self.GetServerUrl(1) + "queryVerify/" + self.code + "/" + self.vcode)
        .then(function (response) {
          var json = response.data;
          if (json.code == 200) {
            self.isShow = true;
            self.hintTxt = `您所查询的是 ${self.datas.business.name} 正品，当前查询次数为 ${json.meta.query_count} 次，感谢查询 ！`;
          } else {
            self.isShow = false;
          }
        }).catch(function (error) {
          self.hintTxt = "防伪码错误！";
          self.isShow = false;
          self.vcode = '';
        })
    },
    CloseTip() {
      self.hintTxt = null;
    },
    ViewMore(datas) {
      if (self.code) {
        this.$router.push({ path: "/ScanCodeRecord" }); // 模板路由跳转
      } else {
        alert("真实码标数据才能查看扫码记录！");
      }
    },
    inited(viewer) {
      self.$viewer = viewer
    },
    PreviewImgs() {
      self.$viewer.show();
      self.$viewer.update();
    },
    ClickMenu(data) {
      if (data.type != 2) {
        window.location.href = data.url;
      } else {
        this.$router.push({ path: "/qr?qr=" + data.qr });
      }
    },
    pageJump(url){
      this.$router.push(url+'/'+this.code)
    }
  }
}
</script>

<style scoped>
*{
	padding:0;
	margin:0;
	list-style: none;
	outline: none !important;
	font-family: "微軟正黑體",sans-serif;
}
input,select {
	border: 0;
	outline:none;
	border-radius: 0;
	appearance:button;
	-moz-appearance:button; /* Firefox */
	-webkit-appearance:button; /* Safari 和 Chrome */
}
.hidebox{
	display: none;
}
.head{
	height: 45px;
	position: fixed;
	width: 100%;
	top: 0;
	left: 0;
	display: block;
	z-index: 2;
	background-color: #063a6b;
}
.classify{
	display: block;
	width: 26px;
	margin-top: 13px;
	margin-left: 15px;
}
.main-body{
	margin-top:45px;
}
.banner img{
	display: block;
	width: 100%;
}
.maib-box{
	padding:15px;
	background-color: #ced8e1;
}
.maib-box ul li{
	margin-bottom:15px;
}
.maib-box ul li:last-child{
	margin-bottom: 0;
}
.fooder{
	padding:20px 0;
	text-align: center;
	margin-top: 40px;
	background-color: #ced8e1;
}

.mask-box{
	z-index: 3;
	position: fixed;
	left:0;right:0;
	top:0;bottom:0;
	background-color: #063a6b;
}
.close{
	display: block;
	width: 22px;
	top: 13px;
	left: 15px;
	position: absolute;
	opacity: 0.6;
}
.nav_list{
	font-size: 24px;
	text-align: center;
	position: relative;
}
.nav_list_blue{
	color: #063a6b;
}
.nav_list_white{
	color: #FFF;
	margin-top:18%;
}
.nav_list li{
	margin-bottom:5%;
	padding-bottom: 5%;
	border-bottom: 2px solid rgba(255,255,255,.1);
}
.nav_list img{
	width: 30px;
	display: table;
	position: absolute;
	margin-top: 1px;
	left: calc(50% - 90px);
}

.from-box{
	padding: 15px;
	background-color: #FFF;
}
.from-input{
	width: calc(100% - 30px);
	margin-top:5px;
	border-radius: 3px;
	height: 38px;
	padding:0 15px;
	line-height: 38px;
	border:1px solid #CCC;
	font-size:17px;
	box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
}
.from-ul{
	margin-top:20px;
	position: relative;
}
.from-button{
	display: table;
	margin:0 auto;
	margin-top:30px;
	padding:10px 0;
	width: 200px;
	font-size:20px;
	color:#27547f;
	text-align: center;
	border-radius: 3px;
	border:1px solid #acbecd;
	background-color: #cdd8e1;
	cursor: pointer;
}
.code{
	width: calc(100% - 130px);
}
.genValidCode{
	font-size:22px;
	color:#0a91f6;
	font-family: arial;
	letter-spacing:4px;
	font-weight: bold;
	text-align: center;
	line-height: 38px;
	cursor: pointer;
}
.quety_return{
	margin-top:80px;
	padding:15px;
	line-height: 25px;
	color:#444;
	background-color: #ced8e1;
}
.fooder_two{
	text-align: center;
	padding:25px;
	color:#444;
	background-color: #FFF;
}
</style>



// WEBPACK FOOTER //
// src/view/Normal08.vue